module.exports = __webpack_public_path__ + "img/screenshot-7.a9ed9444.webp";